import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"

import {
    IOneVerifyPracticeConfiguration,
    IOneVerifyPracticeRole,
    IOneVerifyProfile,
} from "@common-shared/types/responseData/oneVerifyResponseData.types"

import { BrowserStorageType } from "@front-shared/config/general.config"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper"

import { GENERAL_CONFIG } from "../../config/general.config"
import type { IUserDetailsState } from "../../types/state.types"
import { userDetailsGetPracticeUsageQuota } from "../thunks/userDetails.thunks"

const initialState: IUserDetailsState = {
    profile: null,
    selectedPracticeRole: undefined,
    selectedPracticeUsageQuota: null,
    selectedPracticeConfiguration: null,
}

const userDetailsSlice = createSlice({
    name: "userDetails",
    initialState,
    reducers: {
        userDetailsReset: () => initialState,

        userDetailsSetProfile: (
            state,
            action: PayloadAction<IOneVerifyProfile>,
        ) => {
            state.profile = action.payload
        },
        userDetailsSetSelectedPracticeRole: (
            state,
            action: PayloadAction<IOneVerifyPracticeRole>,
        ) => {
            // Save selected practice id in local storage
            // Local storage so it persists across tabs
            BrowserStorageHelper.set(
                GENERAL_CONFIG.browserStorageKeys.selectedPracticeId,
                action.payload.practice.id,
                BrowserStorageType.localStorage,
            )

            // Reload if we are switching practice in the middle
            if (
                state.selectedPracticeRole &&
                state.selectedPracticeRole.practice.id !==
                    action.payload.practice.id
            ) {
                window.location.assign("/")
            } else {
                state.selectedPracticeRole = action.payload
            }
        },
        userDetailsSetSelectedPracticeConfiguration: (
            state,
            action: PayloadAction<IOneVerifyPracticeConfiguration>,
        ) => {
            state.selectedPracticeConfiguration = action.payload
        },
    },
    extraReducers: builder => {
        builder.addCase(
            userDetailsGetPracticeUsageQuota.fulfilled,
            (state, action) => {
                state.selectedPracticeUsageQuota = action.payload
            },
        )
    },
})

export const {
    userDetailsReset,
    userDetailsSetProfile,
    userDetailsSetSelectedPracticeRole,
    userDetailsSetSelectedPracticeConfiguration,
} = userDetailsSlice.actions

export const userDetailsReducer = userDetailsSlice.reducer
